export default __webpack_public_path__ + "static/media/blue_check.14fd2307.svg";